export enum ModalVariant {
  Default = "default",
  Wide = "wide",
}
